import { api, apiUrls } from "../../../utils/api";
import React, { useMemo } from "react";
import { List } from "@mui/material";
import classes from "../../../css/modules/navigation.module.scss";
import { useHistory } from "react-router-dom";
import { routes } from "../../../utils/constants";
import { Item } from "./components/MenuItem";
import { settingActions, SyncErrorType } from "../../../redux/setting";
import { useDispatch, useSelector } from "react-redux";
import authenticationManager from "../../../utils/authenticationManager";
import { SignalRCore } from "../../../utils/signalR/core";
import { AccessEntries, PAGE_ACCESS } from "../../../utils/accessEntries";
import { useAuth0 } from "@auth0/auth0-react";
import { translate } from "../../../utils/translate";

const getAuthorizedRoutes = (logoutAction, accessRights, lastSyncData) => {
  let statusTooltip = translate(lastSyncData.BaseErrorMessage, {
    ErrorDetails: lastSyncData.ErrorDetails,
    ProjectNumber: lastSyncData.ProjectNumber,
    RemainingErrorCount: lastSyncData.RemainingErrorCount
  });

  return [
    {
      text: "Projects",
      href: routes.projects,
      icon: "ico icon-folder",
    },
    {
      text: "Project total overview",
      href: routes.totalProjectOverview,
      access: AccessEntries.TotalProjectOverview,
      icon: "ico icon-calendar-31",
    },
    {
      text: "Department overview",
      href: routes.departmentOverview,
      access: AccessEntries.DepartmentView,
      icon: "ico icon-users",  
    },
    {
      text: "Sync Status",
      href: routes.syncStatus,
      icon: "ico icon-tab deg-90",
      showWarning: lastSyncData.ErrorType == SyncErrorType.ResourceError,
      showError: lastSyncData.ErrorType == SyncErrorType.GeneralError,
      statusTooltip: statusTooltip,
    },
    {
      text: "Settings",
      href: routes.settings,
      icon: "ico icon-cog",
    },
    {
      text: "Logout",
      icon: "ico icon-exit",
      action: logoutAction,
    },
  ].filter((i) => {
    return !(i.access && accessRights[i.access]?.AccessLevel === PAGE_ACCESS.None);
  });
};
const unauthorizedMenuItems = [
  {
    text: "Home",
    icon: "ico icon-home",
    href: routes.projects,
  },
];

export const MenuItems = ({ onLocationChange }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const setting = useSelector((state) => state.setting);
  const { logout } = useAuth0();
  const authorized = true;

  const onMenuClick = (item) => {
    if (item.subItems) return;
    if (item.href) {
      history.push(item.href);
    } else if (typeof item.action === "function") {
      item.action();
    }
    onLocationChange && onLocationChange();
  };
  let menu = useMemo(() => {
    if (window['auth0Config'].USE_AUTH_0) {
      if (authorized) {
        const accessRights = setting.user?.accessRights;
        const logoutAction = () => {
          logout({ logoutParams: { returnTo: window.location.origin } });
          dispatch(settingActions.logOut());
        };
        return getAuthorizedRoutes(logoutAction, accessRights, setting.lastSyncData);
      }
    } else {
      //JWT login
      if (setting.authorized) {
        const accessRights = setting.user?.accessRights;
        const logoutAction = () => {
          api.post(apiUrls.Logout).then(() => {
            authenticationManager.logout();
            dispatch(settingActions.logOut());
            history.push(routes.login);
          });
        };
        return getAuthorizedRoutes(logoutAction, accessRights, setting.lastSyncData);
      }
    }
    return unauthorizedMenuItems;
  }, [authorized, setting.user?.accessRights, setting.authorized, logout, dispatch, history]);

  const pathName = history.location.pathname;

  return (
    <>
      <List className={classes.menu}>
        {menu.map((item, index) => {
          return <Item key={index} item={item} onMenuClick={onMenuClick} pathName={pathName} />;
        })}
      </List>
    </>
  );
};
